import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { getEnvProps } from "../utils/common";
export function initi18n(resourceBundle) {
  var env = getEnvProps();

  var __DEV__ = env.NODE_ENV === "development";

  return i18next.use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: "en",
    ns: ["translation"],
    defaultNS: "translation",
    debug: __DEV__,
    keySeparator: false,
    // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss

    },
    react: {
      wait: true
    },
    resources: {
      en: {
        translation: resourceBundle === null || resourceBundle === void 0 ? void 0 : resourceBundle.appConfigData
      }
    }
  });
}
export default i18next;